import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_CUSTOM_DATE_RANGE_LOADING,
  SET_DATES,
  SET_STAFF_FILTERS_LOADING,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  UPDATE_STAFF_FILTERS
} from "./saga";

import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

const initialState = {
  dataPoints: [],
  pieChart: {},
  table: { colHeaders: [], columns: [], data: [], links: [] },
  isLoading: true,
  filters: {},
  selectedStaffFilters: [],
  numberOfMonths: null,
  filtersDirty: false,
  datesDirty: false,
  staffFiltersLoading: false,
  selectedRequestDates: {},
  selectedRangeOption: {},
  rangeOptions: []
};

export const createReducer = (name) => {
  let suffix = name;
  return handleActions(
    {
      [SET_LOADING + suffix]: (state, action) => ({
        ...state,
        isLoading: action.payload
      }),
      [SET_DATES + suffix]: (state, action) => {
        return {
          ...state,
          selectedRequestDates: action.payload,
          rangeOptions: getRangeOptions(
            state.currentUser.calendarEndDate,
            state.currentUser.theBeginningOfTime
          ),
          selectedRangeOption: getSelectedRangeOption(state.currentUser.calendarEndDate)
        };
      },
      [SET_FILTERS_DIRTY + suffix]: (state, action) => ({
        ...state,
        filtersDirty: action.payload,
        datesDirty: action.payload
      }),
      [FETCH_DATA_SUCCESS + suffix]: (state, action) => ({
        ...state,
        dataPoints: action.payload.dataPoints || state.dataPoints,
        pieChart: action.payload.pieChart || state.pieChart,
        table: action.payload.table || state.table,
        isLoading: false,
        filtersDirty: false
      }),
      [FETCH_FILTERS_SUCCESS + suffix]: (state, action) => ({
        ...state,
        filters: { ...state.filters, staff_values: action.payload },
        selectedStaffFilters:
          action.payload.filter(({ selected }) => selected) || state.selectedStaffFilters
      }),
      [FETCH_CURRENT_USER_SUCCESS + suffix]: (state, action) => ({
        ...state,
        currentUser: action.payload || state.currentUser,
        selectedStaffFilters: []
      }),
      [UPDATE_STAFF_FILTERS + suffix]: (state, action) => ({
        ...state,
        selectedStaffFilters: action.payload || state.selectedStaffFilters,
        filtersDirty: true
      }),
      [UPDATE_DATES + suffix]: (state, action) => ({
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action),
        filtersDirty: true,
        datesDirty: true
      }),
      [UPDATE_CUSTOM_RANGE + suffix]: (state, action) => ({
        ...state,
        selectedRangeOption: action.payload.data,
        selectedRequestDates: getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload.data,
          state.currentUser.theBeginningOfTime
        ),
        filtersDirty: true,
        datesDirty: true
      }),
      [SET_STAFF_FILTERS_LOADING + suffix]: (state, action) => ({
        ...state,
        staffFiltersLoading: action.payload
      }),
      [SET_CUSTOM_DATE_RANGE_LOADING + suffix]: (state, action) => ({
        ...state,
        customDateRangeLoading: action.payload
      })
    },
    initialState
  );
};
